export default __webpack_public_path__ + "static/media/screen4.addf5594.png";